import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Button, ButtonGroup, Typography } from '@mui/material';
import CryptoAssetList from './CryptoAssetList';
import StockAssetList from './StockAssetsList';

export default function AssetTab() {
  
  const [value, setValue] = React.useState('Crypto Asset');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', marginTop: '0px', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="Trade table" 
          variant="scrollable"
          gap={1}
          scrollButtons={true}
          >
                           <Tab  label='Crypto Asset' value="Crypto Asset" />  
      
            <Tab  label='Stock Asset' value="Stock Asset" />
            
          </TabList>
        </Box>
        <TabPanel sx={{width: '100%',   padding: '2px'}} value="Crypto Asset"><CryptoAssetList/></TabPanel>

        <TabPanel sx={{width: '100%',  padding: '2px'}} value="Stock Asset"><StockAssetList/></TabPanel>
        
        
      </TabContext>
    </Box>
  );
}
